import { t, useLocale } from "@/i18n/locale";
import { useState, useSyncExternalStore } from "react";

import { requestPwaUpdate } from "../app/clientContract";
import { needsStaleBuildNotice, subscribeStaleBuild } from "../app/staleBuild";

/**
 * Non-blocking: a part of the screen failed to load because a newer build was
 * deployed. The rest of the page — including unsaved work — stays usable until
 * the user chooses to reload.
 */
export default function StaleBuildNotice() {
  useLocale();
  const stale = useSyncExternalStore(subscribeStaleBuild, needsStaleBuildNotice, needsStaleBuildNotice);
  const [dismissed, setDismissed] = useState(false);
  if (!stale || dismissed) return null;
  return (
    <div className="pwa-stale-notice" role="status">
      <span className="pwa-stale-notice-copy">
        <strong>{t("Ato has been updated")}</strong>
        <span>{t("Reload to load the latest version. Unsaved changes on this page will be lost.")}</span>
      </span>
      <button type="button" className="pwa-stale-notice-action" onClick={() => void requestPwaUpdate()}>
        {t("Reload")}
      </button>
      <button type="button" className="pwa-stale-notice-action" aria-label={t("Dismiss")} onClick={() => setDismissed(true)}>
        ×
      </button>
    </div>
  );
}
